import { render, staticRenderFns } from "./CodeFieldtype.vue?vue&type=template&id=2b29ad8a&"
import script from "./CodeFieldtype.vue?vue&type=script&lang=js&"
export * from "./CodeFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports